import React from "react";

export default (props) => (
  <section id="recruitments">
    <div className="section_title">
      <p>RECRUITMENTS</p>
      <h2>募集要項</h2>
    </div>
    <div className="section_contents">
      <div className="job_list">
        <div className="job_item">
          <h3 className="title has-new"><span className="new">NEW</span>Windows10 Upgrade及び<br />資産管理プロジェクト メンバー</h3>
          <p className="text">Windows10 Upgradeのチェック、及び資産状況の確認PCに関するプロジェクト<br />(未経験者応募可)</p>
          <a className="btn" onClick={props.toRecruit} id="recruit-windows" data-id="recruit-windows">
            募集要項
          </a>
        </div>
        <div className="job_item">
          <h3 className="title has-new"><span className="new">NEW</span>一般職　事務スタッフ<br />総合職　事務スタッフ</h3>
          <p className="text">ビジネスプロセスアウトソーシング業務<br />(未経験者応募可)</p>
          <a className="btn" onClick={props.toRecruit} id="recruit-bpo" data-id="recruit-bpo">
            募集要項
          </a>
        </div>
        <div className="job_item">
          <h3 className="title">IBM i (AS/400)<br />開発エンジニア</h3>
          <p className="text">新規または追加の開発・改修</p>
          <a className="btn" onClick={props.toRecruit} id="recruit-programmer" data-id="recruit-programmer">
            募集要項
          </a>
        </div>
        <div className="job_item">
          <h3 className="title">SAP B-one<br />エンジニア</h3>
          <p className="text">SAP Business oneシステムにおける業務全般</p>
          <a className="btn" onClick={props.toRecruit} id="recruit-sap" data-id="recruit-sap">
            募集要項
          </a>
        </div>
        <div className="job_item">
          <h3 className="title">設備管理MW(IBM Maximo)<br />エンジニア</h3>
          <p className="text">設備管理システムの設計・構築</p>
          <a className="btn" onClick={props.toRecruit} id="recruit-mw" data-id="recruit-mw">
            募集要項
          </a>
        </div>
        <div className="job_item">
          <h3 className="title">IBM i(AS/400)<br />インフラエンジニア</h3>
          <p className="text">IBM i サーバーのインフラ設計・構築、OS・M/W設定</p>
          <a className="btn" onClick={props.toRecruit} id="recruit-infra" data-id="recruit-infra">
            募集要項
          </a>
        </div>
        <div className="job_item">
          <h3 className="title">PCキッティング<br />プロジェクトマネージャー</h3>
          <p className="text">IT機器LCMサービス提供における管理全般</p>
          <a className="btn" onClick={props.toRecruit} id="recruit-pm" data-id="recruit-pm">
            募集要項
          </a>
        </div>
        <div className="job_item">
          <h3 className="title">PCキッティング<br />リーダー</h3>
          <p className="text">PCキッティング・チームのリーダー</p>
          <a className="btn" onClick={props.toRecruit} id="recruit-pk" data-id="recruit-pk">
            募集要項
          </a>
        </div>
        <div className="job_item">
          <h3 className="title">人工知能(IBM Watson)<br />開発エンジニア</h3>
          <p className="text">人工知能を活用したソリューション、システムの設計・開発</p>
          <a className="btn" onClick={props.toRecruit} id="recruit-ai" data-id="recruit-ai">
            募集要項
          </a>
        </div>
      </div>
      <div className="recruit_links">
        <div className="links_item entry">
          <p className="text">経験者採用にご応募の方はこちら</p>
          <a className="btn" target="_blank" href="/contact/recruitment-form" rel="noopener noreferrer">
            ENTRY
          </a>
        </div>
      </div>
    </div>
  </section>
)


// WEBPACK FOOTER //
// ./src/Home/Recruitments.js